import { forwardRef, useEffect, useRef } from "react";
import { SlideEyebrow, SlideHeading } from "../common.tsx";

const TRACK_LABELS = ["Up next", "On deck", "In pipeline", "Exploring", "Future", "Future"];

interface Props {
  index: number;
  whatsNext: string[];
}

export const WhatsNextSlide = forwardRef<HTMLElement, Props>(function WhatsNextSlide(
  { index, whatsNext },
  ref
) {
  const listRef = useRef<HTMLOListElement>(null);

  useEffect(() => {
    const list = listRef.current;
    if (!list) return;

    const line = list.previousElementSibling as HTMLElement | null;
    const items = list.querySelectorAll<HTMLElement>(".dz-timeline-item");

    const reset = () => {
      if (line) line.classList.remove("dz-timeline-line--visible");
      items.forEach((el) => el.classList.remove("dz-timeline-item--visible"));
    };

    const run = () => {
      if (line) line.classList.add("dz-timeline-line--visible");
      items.forEach((el) => el.classList.add("dz-timeline-item--visible"));
    };

    const io = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) { run(); io.disconnect(); }
        }
      },
      { threshold: 0.15 }
    );

    if (list) io.observe(list);
    return () => { io.disconnect(); reset(); };
  }, [whatsNext.length]);

  return (
    <section ref={ref} className="dz-slide">
      <div className="dz-container">
        <SlideEyebrow index={index} label="Roadmap" />
        <SlideHeading plain="What's "><em>next</em>.</SlideHeading>
        <p className="dz-lede">
          Ambition, framed as roadmap. Items below are not built today.
        </p>
        <div className="dz-timeline-wrap">
          <div className="dz-timeline-line" />
          <ol className="dz-timeline" ref={listRef}>
          {whatsNext.map((x, i) => (
            <li
              className={i === 0 ? "dz-timeline-item dz-timeline-item--next" : "dz-timeline-item"}
              key={i}
              style={{ "--dz-tl-delay": `${0.1 + i * 0.15}s` } as React.CSSProperties}
            >
              <div className="dz-timeline-dot" />
              <div className="dz-timeline-track">{TRACK_LABELS[i] ?? "Future"}</div>
              <div className="dz-timeline-body">
                <span>{x}</span>
                {i === 0 && (
                  <span className="dz-ti-pill">
                    <span className="dz-pulse-dot" />
                    Next up
                  </span>
                )}
              </div>
            </li>
          ))}
          </ol>
        </div>
      </div>
    </section>
  );
});

